var map = {
	"./screen1.png": 144,
	"./screen2.png": 145,
	"./screen3.png": 146,
	"./screen4.png": 147,
	"./screen5.png": 148,
	"./screen6.png": 149,
	"./screen7.png": 150
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 143;